import React from 'react';
import { BoxTabs as BoxTabsNew } from './BoxTabs';
import { convertOldBoxTabsProps } from './converter.old';
import type { OldBoxTabsProps } from './converter.old';

export type BoxTabsProps = OldBoxTabsProps;

export const BoxTabs: React.FC<BoxTabsProps> = (props) => <BoxTabsNew {...convertOldBoxTabsProps(props)} />;
